import { getPrettyName } from "@utils/user-utils";
/** Returns the markup creator member */
export function getMarkupCreator({
  creatorId,
  companyMembers,
  projectMembers
}) {
  const creatorCompanyMember = companyMembers.find(member => member.identity === creatorId);
  const creatorProjectMember = projectMembers.find(member => member.identity === creatorId);

  // Give priority to the company level member entity
  return creatorCompanyMember || creatorProjectMember;
}

/** Returns the markup creator name */
export function getMarkupCreatorName({
  creatorId,
  companyMembers,
  projectMembers
}) {
  const creatorMember = getMarkupCreator({
    creatorId,
    companyMembers,
    projectMembers
  });
  const name = getPrettyName(creatorMember);
  return name !== "" ? name : undefined;
}